import React from 'react';
import { useSelector } from 'react-redux';
import Modal from 'react-bootstrap/Modal';

import { PosPlugin } from 'plugins/plugin';
import { getModalTitle } from 'reducers/returnProducts';

import { getExchangeState } from '../rdx';

const UIExchangeModalTitle: PosPlugin['UIExchangeModalTitle'] = () => {
  const exchangeState = useSelector(getExchangeState);
  const modalTitle = useSelector(getModalTitle);
  const exchangeTitle =
    exchangeState.exchangeStep === 1
      ? modalTitle.replace('Return', 'Exchange')
      : modalTitle;

  return <Modal.Title>{exchangeTitle}</Modal.Title>;
};

export default UIExchangeModalTitle;
